<template>
  <div>
    <v-data-table
      dense
      item-key="_id"
      class="transparent mt-2"
      :items="productionColumns"
      :headers="headers"
      disable-pagination
      hide-default-footer
      :loading="loading"
    >
      <template #loading>
        Loading
      </template>
      <template #item.display="{ item, index }">
        <v-switch
          hide-details
          v-model="item.display"
          @change="ignoreColumn(item, index)"
          label="Show/Hide"
        ></v-switch>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
  name: 'ColumnConfig',
  data() {
    return {
      loading: false,
      headers: [
        {
          text: this.$t('production.column'),
          value: 'text',
          width: '60%',
        },
        {
          text: this.$t('production.display'),
          value: 'display',
        },
      ],
    };
  },
  computed: {
    ...mapState('webApp', ['appSchema', 'activeAppId']),
    ...mapState('productionLog', [
      'assetId',
    ]),
    productionColumns() {
      let columns = [];
      const schemaDetails = Array.isArray(this.appSchema)
        ? this.appSchema.find((schema) => schema.assetId === this.assetId
          && Array.isArray(schema.productionHeaders)
          && schema.productionHeaders.length)
        : null;
      if (schemaDetails && Array.isArray(schemaDetails.productionHeaders)
        && schemaDetails.productionHeaders.length) {
        columns = [...schemaDetails.productionHeaders];
      }
      return columns;
    },
  },
  methods: {
    ...mapMutations('productionLog', ['setLoading']),
    ...mapActions('webApp', ['getAppSchema', 'updateAppSchema']),
    async ignoreColumn(item, index) {
      const updatedSchema = Array.isArray(this.appSchema)
        ? JSON.parse(JSON.stringify(this.appSchema))
        : [];
      const schemaIndex = updatedSchema.findIndex((schema) => schema.assetId === this.assetId
        && Array.isArray(schema.productionHeaders)
        && schema.productionHeaders.length);
      if (schemaIndex !== -1) {
        updatedSchema[schemaIndex].productionHeaders[index] = item;
      }
      this.setLoading(true);
      try {
        await this.updateAppSchema({ appSchema: updatedSchema, saveForAll: false });
        await this.getAppSchema();
      } finally {
        this.setLoading(false);
      }
    },
  },
};
</script>
